const COMPANIES_TO_LOAD = 50

export default COMPANIES_TO_LOAD
